export interface UsageGauges {
  /** 0–1 utilization for the current 5-hour session window, or null if absent. */
  sessionUsage: number | null;
  /** 0–1 utilization; max across all weekly gauges (all-models + per-model), or null. */
  weeklyUsage: number | null;
}

/**
 * Parse the plain-text output of `claude -p "/usage"` into the two gauge
 * numbers we store. Best-effort: any gauge that isn't present becomes null so
 * the poller can skip reporting (e.g. API-key pods have no subscription gauges).
 */
export function parseUsageGauges(stdout: string): UsageGauges {
  const session = stdout.match(/Current session:\s*(\d+(?:\.\d+)?)%\s*used/i);
  const weekly = [...stdout.matchAll(/Current week[^:\n]*:\s*(\d+(?:\.\d+)?)%\s*used/gi)];
  return {
    sessionUsage: session ? Number(session[1]) / 100 : null,
    weeklyUsage: weekly.length ? Math.max(...weekly.map((m) => Number(m[1]))) / 100 : null,
  };
}
